
<div :style="'height:' + (height + 139) + 'px'" class="white dialog-border" style="overflow: hidden">
    <v-btn
        color="primary"
        fab
        small
        dark
        bottom
        right
        absolute
        style="margin-bottom: 75px; margin-right: 75px"
        @click = "onMail"
    >
        <v-icon>{{ showMailSlide ? 'mdi-close' : 'mdi-email-outline' }}  </v-icon>
    </v-btn>

    <v-expand-x-transition>
        <v-card elevation="10" v-show="showMailSlide" class="dialog-border " style="position: absolute; width: 930px; height: calc(100% - 45px); right: 73px; top: 5px; z-index: 1">
            <div class="w-100 h-100 white">
                <c-inc-mail-editor
                    :mail        = "forwardMail"
                    :incident    = "incident"
                    :step        = "0"
                    :unit        = "unit"
                    :units       = "units"
                    @sended      = "onSended"
                />
            </div>
        </v-card>
    </v-expand-x-transition>

    <div style="height: 120px" class=" pa-3">
        <div class="v-flex">
            <div class = "mail-subject">
                {{ mail.subject }}
            </div>
            <v-spacer></v-spacer>
            <div class="v-flex">
                <c-toolbar-button
                    size="22"
                    color="primary"
                    icon="mdi-arrow-right"
                    tooltip="Zum Ereignis wechseln"
                    @click = "onIncident"
                />
            </div>            </div>
        <div class="v-flex mt-3">
            <div class="mr-4">
                <p-inc-outbox-avatar
                    :sender = "mail.replyTo[0].email"
                    :dense  = "false"
                />
            </div>
            <div>
                <div class = "mail-sender">
                    {{ from }}
                </div>
                <div class="mail-receiver">
                    <span><b>An:</b> {{ to }}</span>
                </div>
                <div class="mail-receiver">
                    <span><b>Cc:</b> {{ cc }}</span>
                </div>
            </div>

        </div>

    </div>
    <p-inc-outbox-attachments
        style="margin-left: 80px"
        :attachments = "mail.attachments"
    />
    <div class="pa-3 pr-2" style="margin-top: 7px;">
        <div v-html="body" class="mail-body" style="overflow-y: scroll" :style="'max-height: ' + (height - 70) + 'px'">

        </div>
    </div>

</div>
